import { NgModule } from '@angular/core';
import { GacoiLibComponent } from './gacoi-lib.component';

@NgModule({
  declarations: [GacoiLibComponent],
  imports: [
  ],
  exports: [GacoiLibComponent]
})
export class GacoiLibModule { }
